// This file is part of Coog. The COPYRIGHT file at the top level of
// this repository contains the full copyright notices and license terms.
import React from 'react';
import PropTypes from 'prop-types';

import { find } from 'lodash-es';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import InnerLink from './InnerLink';

const BeneficiariesBlock = ({ strings, contract, clauses }) => {
  const { beneficiaries, covered_elements: coveredElements } = contract;

  const getCoveredElement = beneficiary => {
    try {
      // eslint-disable-next-line prefer-destructuring
      const id = beneficiary.option.covered_element.id;
      const coveredElement = find(coveredElements, ['id', id]);
      return <InnerLink route={`/party/${id}`} label={coveredElement.rec_name} value={id} />;
    } catch (error) {
      return '';
    }
  };
  const getBeneficiary = beneficiary => {
    try {
      // eslint-disable-next-line prefer-destructuring
      return beneficiary.reference ? (
        beneficiary.reference
      ) : (
        <InnerLink
          route={`/party/${beneficiary.party.id}`}
          label={beneficiary.party.rec_name}
          value={beneficiary.party.id}
        />
      );
    } catch (error) {
      return '';
    }
  };
  const getShare = beneficiary => {
    try {
      // eslint-disable-next-line prefer-destructuring
      return `${beneficiary.share * 100}%`;
    } catch (error) {
      return '';
    }
  };

  const getClause = beneficiary => {
    try {
      // eslint-disable-next-line prefer-destructuring
      const id = beneficiary.option.beneficiary_clause.id;
      const clause = find(clauses, ['id', id]);
      return clause.rec_name;
    } catch (error) {
      return '';
    }
  };

  const getCoverage = beneficiary => beneficiary.option.rec_name;

  return (
    <div className="beneficiaries block">
      <Table className="table beneficiaries">
        <TableHead>
          <TableRow>
            <TableCell>
              {strings['contract.beneficiaries.table.covered.label'] || 'Personne Couverte'}
            </TableCell>
            <TableCell>
              {strings['contract.beneficiaries.table.coverage.label'] || 'Garantie'}
            </TableCell>
            <TableCell>
              {strings['contract.beneficiaries.table.beneficiary_clause.label'] ||
                'Clause Bénéficiaire'}
            </TableCell>
            <TableCell>
              {strings['contract.beneficiaries.table.share.label'] || 'Quotité'}
            </TableCell>
            <TableCell>
              {strings['contract.beneficiaries.table.beneficiary.label'] || 'Bénéficiaire'}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {beneficiaries && Array.isArray(beneficiaries)
            ? beneficiaries.map(row => (
              <TableRow key={row.id}>
                <TableCell component="th" scope="row">
                  {getCoveredElement(row)}
                </TableCell>
                <TableCell component="th" scope="row">
                  {getCoverage(row)}
                </TableCell>
                <TableCell component="th" scope="row">
                  {getClause(row)}
                </TableCell>
                <TableCell component="th" scope="row">
                  {getShare(row)}
                </TableCell>
                <TableCell component="th" scope="row">
                  {getBeneficiary(row)}
                </TableCell>
              </TableRow>
              ))
            : undefined}
        </TableBody>
      </Table>
    </div>
  );
};

BeneficiariesBlock.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  // loading: PropTypes.objectOf(PropTypes.bool).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  contract: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  clauses: PropTypes.array.isRequired
};

BeneficiariesBlock.defaultProps = {
  strings: {}
};
export default BeneficiariesBlock;
